@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.custom-tooltip {
  background-color: @insights-page--tooltip--background-color;
  color: @insights-page--tooltip--text-color;
  border-radius: 5px;
  padding: 10px;
  text-align: center;
}

.content {
  line-height: 18px;
  font-size: 14px;
}
